
  var _styles = {
  "activity-end-desc": {
    "color": "rgb(78,102,128)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": "0.33333rem"
  }
};



  module.exports = _styles;
  